import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "plan-content"
}
const _hoisted_2 = { class: "w-100 d-flex justify-content-between gap-20 align-items-end" }
const _hoisted_3 = { class: "headers pdb-5 pdt-15" }
const _hoisted_4 = {
  key: 0,
  class: "iatse-icon-info-circle-solid icon_rotate_0 icon_danger icon-tooltip icon-tooltip-secondary fs-lg"
}
const _hoisted_5 = { class: "tooltip-text left-20" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { class: "radio-group bold highlight" }
const _hoisted_10 = { class: "radio-buttons w-40 w-sm-100" }
const _hoisted_11 = ["id", "value"]
const _hoisted_12 = ["for"]
const _hoisted_13 = {
  key: 0,
  class: "w-full"
}
const _hoisted_14 = {
  key: 1,
  class: "w-full justify-content-start"
}
const _hoisted_15 = { class: "action-buttons flex-md-row flex-column sm-pdl-0 sm-pdr-0" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 2,
  class: "d-flex flex-column align-items-center gap-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", null, "To Continue Please...", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createTextVNode("Please "),
  /*#__PURE__*/_createElementVNode("a", { href: "profile.personal.edit" }, "update your personal information"),
  /*#__PURE__*/_createTextVNode(" to include your correct date of birth.")
], -1)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_CoveredCard = _resolveComponent("CoveredCard")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_DateInput = _resolveComponent("DateInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Alerts, { errors: _ctx.generalErrors }, null, 8, ["errors"]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_MessageCard, {
          key: 0,
          message: "Please review your mailing address and/or payment destination below. <br />\n            Please note: Updating mailing address below will update your primary address on file with the Fund Office for all your correspondences. <br />\n            Updating direct deposit information below will update the payment setup on file with the Fund Office for all your payments (Claims and other Benefits if applicable).",
          type: "primary",
          iconClass: "iatse-icon-alarm",
          classes: "info_card_full"
        }))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 1 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!_ctx.loading && _ctx.requestType.key === 'medicare')
            ? (_openBlock(), _createBlock(_component_CoveredCard, {
                key: 0,
                links: _ctx.claimStore.claimLinks,
                small: true
              }, null, 8, ["links"]))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.person && _ctx.person.DateofBirth)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                id: "check-destination-form",
                class: "form",
                method: "POST",
                onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitData && _ctx.submitData(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_TextInput, {
                    type: "text",
                    label: "Participant ID",
                    placeholder: "Enter Participant ID",
                    max: 25,
                    modelValue: _ctx.person.PersonID,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.person.PersonID) = $event)),
                    readonly: true,
                    "custom-class": "w-full"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_SelectComponent, {
                    label: "Check Type",
                    selectedOption: _ctx.requestType,
                    "onUpdate:selectedOption": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestType) = $event)),
                    options: _ctx.checkTypes,
                    singleArrow: true,
                    readonly: true,
                    "custom-class": "w-full"
                  }, null, 8, ["selectedOption", "options"])
                ]),
                _createVNode(_component_TextInput, {
                  type: "text",
                  label: "First Name",
                  placeholder: "Enter First Name",
                  max: 12,
                  modelValue: _ctx.person.FirstName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.person.FirstName) = $event)),
                  readonly: true
                }, null, 8, ["modelValue"]),
                _createVNode(_component_TextInput, {
                  type: "text",
                  label: "Last Name",
                  placeholder: "Enter Last Name",
                  max: 25,
                  modelValue: _ctx.person.LastName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.person.LastName) = $event)),
                  readonly: true
                }, null, 8, ["modelValue"]),
                _createVNode(_component_DateInput, {
                  label: "DOB",
                  modelValue: _ctx.person.DateofBirth,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.person.DateofBirth) = $event)),
                  readonly: true
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.checkType === 'check')
                    ? (_openBlock(), _createElementBlock("h4", {
                        key: 0,
                        class: _normalizeClass({'position-relative': _ctx.addressErrors})
                      }, [
                        _createTextVNode("Address for Check Destination currently on File "),
                        (_ctx.addressErrors)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_4, [
                              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.addressErrors), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 2))
                    : (_openBlock(), _createElementBlock("h4", _hoisted_6, "Current Payment Destination")),
                  (_ctx.checkType === 'directdeposit')
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_7, " Current Banking Information "))
                    : (_openBlock(), _createElementBlock("h5", _hoisted_8, " This is your Primary address for all correspondences from the Fund Office "))
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass([{'highlight bg-light-green': _ctx.checkType == option.value}, "radio-button bordered-card bordered-card_secondary pdt-20 pdb-20 align-items-start"])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: `PaymentOption${index + 1}`,
                          name: "PaymentOption",
                          value: option.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.checkType) = $event))
                        }, null, 8, _hoisted_11), [
                          [_vModelRadio, _ctx.checkType]
                        ]),
                        _createElementVNode("label", {
                          class: "body-text",
                          for: `PaymentOption${index + 1}`
                        }, _toDisplayString(option.label), 9, _hoisted_12)
                      ], 2))
                    }), 128))
                  ])
                ]),
                (_ctx.address && _ctx.checkType === 'check')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_TextInput, {
                        type: "text",
                        name: "mixed",
                        label: "Address 1",
                        placeholder: "Enter Address 1",
                        max: 30,
                        modelValue: _ctx.address.Street1,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.address.Street1) = $event)),
                        required: true,
                        "is-required": true
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        name: "mixed",
                        label: "Address 2",
                        placeholder: "Enter Address 2",
                        max: 30,
                        modelValue: _ctx.address.Street2,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.address.Street2) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        name: "mixed",
                        label: "Address 3",
                        placeholder: "Enter Address 3",
                        max: 30,
                        modelValue: _ctx.address.Street3,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.address.Street3) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        placeholder: "Enter City",
                        label: ['US', 'CA', 'MX'].includes(_ctx.address.Country?.key) ? 'City' : 'City/State',
                        max: 25,
                        modelValue: _ctx.address.City,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.address.City) = $event)),
                        required: true,
                        error: _ctx.errors?.City,
                        isRequired: true
                      }, null, 8, ["label", "modelValue", "error"]),
                      _createVNode(_component_SelectComponent, {
                        label: "Country",
                        selectedOption: _ctx.address.Country,
                        "onUpdate:selectedOption": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.address.Country) = $event)),
                        options: _ctx.profileStore.countries,
                        "single-arrow": true
                      }, null, 8, ["selectedOption", "options"]),
                      _createVNode(_component_SelectComponent, {
                        label: "State",
                        selectedOption: _ctx.address.State,
                        "onUpdate:selectedOption": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.address.State) = $event)),
                        options: _ctx.filteredStates,
                        "single-arrow": true,
                        error: _ctx.errors ? _ctx.errors['State.key'] : null,
                        isRequired: ['US', 'CA', 'MX'].includes(_ctx.address.Country?.key),
                        readonly: !['US', 'CA', 'MX'].includes(_ctx.address.Country?.key)
                      }, null, 8, ["selectedOption", "options", "error", "isRequired", "readonly"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        label: "ZIP Code",
                        name: "number",
                        placeholder: "Enter Postal Code",
                        max: 9,
                        modelValue: _ctx.address.Zip,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.address.Zip) = $event)),
                        required: true,
                        "is-required": true
                      }, null, 8, ["modelValue"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_TextInput, {
                        type: "text",
                        name: "mixed",
                        label: "Bank Name",
                        placeholder: "Enter Bank Name",
                        max: 30,
                        modelValue: _ctx.bank.BankClassDescription,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.bank.BankClassDescription) = $event)),
                        required: true,
                        "is-required": true,
                        error: _ctx.errors?.BankClassDescription
                      }, null, 8, ["modelValue", "error"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        name: "number",
                        label: "Routing (ABA)",
                        placeholder: "Enter Routing (ABA)",
                        max: 20,
                        modelValue: _ctx.bank.RoutingCode,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.bank.RoutingCode) = $event)),
                        required: true,
                        "is-required": true,
                        error: _ctx.errors?.RoutingCode
                      }, null, 8, ["modelValue", "error"]),
                      _createVNode(_component_SelectComponent, {
                        label: "Account Type",
                        selectedOption: _ctx.bank.AcctType,
                        "onUpdate:selectedOption": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.bank.AcctType) = $event)),
                        options: _ctx.accountTypes,
                        "single-arrow": true,
                        error: _ctx.errors?.AccountType
                      }, null, 8, ["selectedOption", "options", "error"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        name: "number",
                        label: "Account Number",
                        placeholder: "Enter Account Number",
                        max: 20,
                        modelValue: _ctx.bank.BankAcctNo,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.bank.BankAcctNo) = $event)),
                        required: true,
                        "is-required": true,
                        error: _ctx.errors?.BankAcctNo
                      }, null, 8, ["modelValue", "error"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        name: "number",
                        label: "Repeat Account Number",
                        placeholder: "Repeat Account Number",
                        max: 20,
                        modelValue: _ctx.bank.RepeatBankAcctNo,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.bank.RepeatBankAcctNo) = $event)),
                        required: true,
                        "is-required": true,
                        error: _ctx.errors?.RepeatBankAcctNo
                      }, null, 8, ["modelValue", "error"])
                    ])),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("button", {
                    onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetModal && _ctx.resetModal(...args)), ["prevent"])),
                    class: "btn btn-secondary",
                    disabled: _ctx.loadingSubmit
                  }, " Discard ", 8, _hoisted_16),
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-primary",
                    disabled: _ctx.loadingSubmit
                  }, _toDisplayString(_ctx.loadingSubmit ? 'Submitting...' : 'Submit'), 9, _hoisted_17)
                ])
              ], 32))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
        ]))
  ], 64))
}